/* ============================================================================
FILE: po-katupirsia9-memoire-d-or-texts-fr-en-es-20260326.js
MODE: protected trilingual with FR / EN / ES buttons + lexicon locking
API:  window.PoKatupirsia9MemoireDOrTextsFR_EN_ES_20260326
ROOT: .po-axis-section[data-po-axis='memoire_d_or']
============================================================================ */

(function(){
  "use strict";

  if (window.__PO_KATUPIRSIA9_MEMOIRE_D_OR_TEXTS_20260326__) return;
  window.__PO_KATUPIRSIA9_MEMOIRE_D_OR_TEXTS_20260326__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var ROOT_SEL = ".po-axis-section[data-po-axis='memoire_d_or']";

  function clampStr(v){ return (v == null) ? "" : String(v); }

  function normLang(raw){
    var s = clampStr(raw).toLowerCase().trim().replace(/_/g, "-");
    if (s.indexOf("es") === 0 || s.indexOf("pt") === 0) return "ES";
    if (s.indexOf("en") === 0) return "EN";
    return "FR";
  }

  function syncDocumentLang(lang){
    try{ document.documentElement.setAttribute("lang", (normLang(lang) || "FR").toLowerCase()); }catch(e){}
  }

  function getBrowserLang(){
    var dl = document && document.documentElement ? (document.documentElement.getAttribute("lang") || "") : "";
    if (dl) return normLang(dl);
    if (typeof navigator !== "undefined"){
      if (navigator.languages && navigator.languages.length) return normLang(navigator.languages[0] || "fr");
      if (navigator.language) return normLang(navigator.language || "fr");
    }
    return "FR";
  }

  function readStoredLang(){
    try{
      var v = localStorage.getItem(STORAGE_KEY);
      if (v) return normLang(v);
    }catch(e){}
    try{
      var v2 = localStorage.getItem(STORAGE_KEY_COMPAT);
      if (v2) return normLang(v2);
    }catch(_e){}
    return "";
  }

  function storeLang(lang3){
    var lang = normLang(lang3 || "FR");
    try{ localStorage.setItem(STORAGE_KEY, lang); }catch(e){}
    try{ localStorage.setItem(STORAGE_KEY_COMPAT, lang); }catch(_e){}
    syncDocumentLang(lang);
    return lang;
  }

  function getLang(){
    return readStoredLang() || getBrowserLang() || "FR";
  }

  function notifyLocaleChanged(){
    try{
      window.dispatchEvent(new Event("po:locale-changed"));
    }catch(e){
      try{
        var ev = document.createEvent("Event");
        ev.initEvent("po:locale-changed", true, true);
        window.dispatchEvent(ev);
      }catch(_e){}
    }
  }

  function escapeRegExp(s){
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function uniqPush(arr, v){
    if (!v) return;
    for (var i=0;i<arr.length;i++) if (arr[i] === v) return;
    arr.push(v);
  }

  function buildVariants(term){
    var out = [];
    var t = clampStr(term);
    if (!t) return out;
    uniqPush(out, t);
    uniqPush(out, t.replace(/’/g, "'"));
    uniqPush(out, t.replace(/'/g, "’"));
    uniqPush(out, t.replace(/œ/g, "oe").replace(/Œ/g, "OE"));
    uniqPush(out, t.replace(/oe/g, "œ").replace(/OE/g, "Œ"));
    return out;
  }

  function getProtectTerms(){
    return [
      "Mémoire d’Or",
      "Souvenir d’Or",
      "Or de mémoire",
      "Souffle d’Or",
      "Katûvýsissence",
      "Katûvýs",
      "Isqun",
      "Threnisqun",
      "Δτ",
      "Àṣẹxel’Or",
      "Katûpirsia 9",
      "Katûpirsia"
    ];
  }

  function buildProtectMatcher(){
    var base = getProtectTerms();
    var variants = [];
    for (var i=0;i<base.length;i++){
      var list = buildVariants(base[i]);
      for (var j=0;j<list.length;j++) uniqPush(variants, list[j]);
    }
    variants.sort(function(a,b){ return b.length - a.length; });
    var parts = [];
    for (var k=0;k<variants.length;k++) parts.push(escapeRegExp(variants[k]));
    return new RegExp(parts.join("|"), "g");
  }

  var PROTECT_MATCHER = buildProtectMatcher();

  function isLockedNode(node){
    var p = node && node.parentNode;
    while (p && p.nodeType === 1){
      if (p.classList){
        if (p.classList.contains("po-lex-protect")) return true;
        if (p.classList.contains("notranslate")) return true;
      }
      if (String(p.getAttribute && p.getAttribute("translate") || "").toLowerCase() === "no") return true;
      p = p.parentNode;
    }
    return false;
  }

  function protectTextNode(doc, textNode){
    if (!doc || !textNode || !textNode.nodeValue) return;
    if (isLockedNode(textNode)) return;
    var txt = String(textNode.nodeValue);
    if (!PROTECT_MATCHER.test(txt)) return;
    PROTECT_MATCHER.lastIndex = 0;

    var frag = doc.createDocumentFragment();
    var last = 0;
    txt.replace(PROTECT_MATCHER, function(m, idx){
      if (idx > last) frag.appendChild(doc.createTextNode(txt.slice(last, idx)));
      var span = doc.createElement("span");
      span.className = "po-lex-protect notranslate";
      span.setAttribute("translate", "no");
      span.textContent = m;
      frag.appendChild(span);
      last = idx + m.length;
      return m;
    });
    if (last < txt.length) frag.appendChild(doc.createTextNode(txt.slice(last)));
    if (textNode.parentNode) textNode.parentNode.replaceChild(frag, textNode);
  }

  function protectHTML(html){
    var s = clampStr(html);
    if (!s) return "";
    var tpl = document.createElement("template");
    tpl.innerHTML = s;
    var root = tpl.content || tpl;

    var walker;
    try{
      walker = document.createTreeWalker(
        root,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode: function(n){
            if (!n || !n.nodeValue) return NodeFilter.FILTER_REJECT;
            if (isLockedNode(n)) return NodeFilter.FILTER_REJECT;
            return NodeFilter.FILTER_ACCEPT;
          }
        },
        false
      );
    }catch(e){ return s; }

    var nodes = [];
    var t;
    while ((t = walker.nextNode())) nodes.push(t);
    for (var i=0;i<nodes.length;i++) protectTextNode(document, nodes[i]);
    return tpl.innerHTML;
  }

  function setSlotText(root, slot, txt){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (el) el.textContent = clampStr(txt);
  }

  function setSlotHTML(root, slot, html){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (el) el.innerHTML = protectHTML(clampStr(html));
  }

  function setSlotImgSrc(root, slot, src, alt){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    var media = el.parentElement || null;
    if (src){
      el.setAttribute("src", clampStr(src));
      el.setAttribute("alt", clampStr(alt));
      el.removeAttribute("hidden");
      if (media) media.removeAttribute("hidden");
    } else {
      el.removeAttribute("src");
      el.setAttribute("alt", "");
      el.setAttribute("hidden", "");
      if (media) media.setAttribute("hidden", "");
    }
  }

  function renderListInto(root, slot, items){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    el.innerHTML = "";
    (items || []).forEach(function(item){
      var li = document.createElement("li");
      li.textContent = clampStr(item);
      el.appendChild(li);
    });
  }

  function renderWordBlocks(root, slot, blocks){
    var host = root.querySelector("[data-po-slot='" + slot + "']");
    if (!host) return;
    host.innerHTML = "";
    (blocks || []).forEach(function(b){
      var wrap = document.createElement("div");
      wrap.className = "po-axis-wb";
      var h = document.createElement("div");
      h.className = "po-axis-wb__h";
      h.textContent = clampStr((b || {}).head || "");
      var t = document.createElement("div");
      t.className = "po-axis-wb__t";
      t.textContent = clampStr((b || {}).text || "");
      wrap.appendChild(h);
      wrap.appendChild(t);
      host.appendChild(wrap);
    });
  }

  var CHIP_CONCEPT = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Memoire_doree_conceptuel.png?v=1773258221";
  var CHIP_FUNCTION = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Memoire_doree_fonctionnel.png?v=1773258221";

  var CONTENT = {
    "FR": {
      "title": "Mémoire d’Or",
      "kicker": "Extrait du <em>Katûpirsia&nbsp;9 — Àṣẹxel’Or</em><br />(Katûvýsissence, conservation spiralée du Souffle et mémoire vibrante)",
      "h_def": "Définition opérative",
      "chips": ["Idéogramme conceptuel", "Idéogramme fonctionnel"],
      "chip_urls": [CHIP_CONCEPT, CHIP_FUNCTION],
      "def_short": "Conservation spiralée du Souffle dans la Katûvýsissence.",
      "def_long": "<p>Mémoire d’Or est donnée, dans <em>Katûpirsia&nbsp;9</em>, avec Souvenir d’Or et Or de mémoire. Le tableau canonique des champs et mémoires du Souffle en donne la fonction avec netteté : conservation spiralée du Souffle dans la Katûvýsissence. Sa nature y est formulée comme mémoire vibrante.</p><p>Dans la lecture systémique intégrée, Mémoire d’Or appartient au plan Katûvýsissence / Mémoire. Sa fonction globale reste identique : conserver le Souffle sans le figer, maintenir la continuité spiralée du monde dans la mémoire, et faire de la trace un principe actif de cohérence.</p><p>Les développements sur la persistance du Souffle précisent cette logique. La mémoire n’y est pas dépôt, mais transformation continue : rien ne se perd, tout se réaccorde sur un autre plan. Le manuscrit va jusqu’à dire que la lumière ne se contente pas d’éclairer les formes : elle les souvient. Mémoire d’Or désigne ainsi la lumière devenue mémoire incarnée de la vibration, la trace active par laquelle le réel continue de se rappeler.</p><p>Dans la dynamique du souvenir, chaque forme garde mémoire de sa vibration originelle et l’exprime sous une amplitude nouvelle. Mémoire d’Or ne conserve donc pas un passé immobile ; elle redistribue le Souffle, relie la matière, la lumière et la conscience, et maintient l’univers dans une fidélité active à sa propre origine.</p>",
      "h_features": "Dynamiques opératives",
      "h_questions": "Applications / repères",
      "hint_fold": "déplier",
      "h_family": "Liens systémiques",
      "h_wordbuild": "Construction du terme",
      "features": [
        "Conservation spiralée : Mémoire d’Or conserve le Souffle dans la Katûvýsissence sans le figer.",
        "Mémoire vibrante : la trace reste active, transmissible et opérante dans le présent.",
        "Lumière mémorielle : la lumière y devient mémoire incarnée de la vibration.",
        "Continuité du réel : chaque forme garde mémoire de son origine et l’exprime sous une figure nouvelle.",
        "Plan mémoriel du système : dans la lecture intégrée, elle appartient au plan Katûvýsissence / Mémoire."
      ],
      "questions": [
        "La trace rencontrée relève-t-elle d’un simple reste, ou d’une mémoire encore active dans le champ ?",
        "Qu’est-ce qui se conserve ici sans se figer : un rythme, une lumière, une forme, une conscience ?",
        "Comment la mémoire agit-elle comme continuité plutôt que comme retour immobile du passé ?",
        "Où la vibration devient-elle lumière mémorielle, et la lumière mémoire opérative ?"
      ],
      "example_box": "<div><strong>Ex.</strong> Dans une lecture posœnnoïale, lorsqu’une œuvre ou un geste garde la trace active d’une vibration antérieure tout en la transformant en présence nouvelle, cette tenue peut être lue comme un effet de Mémoire d’Or.</div>",
      "family_1": "<p><strong>Liens internes :</strong> <span>Mémoire d’Or</span> appartient au plan <span>Katûvýsissence / Mémoire</span>, avec <span>Or de mémoire</span> et <span>Souvenir d’Or</span>. Elle entretient un rapport direct avec le <span>Souffle d’Or</span>, dont elle conserve la trame spiralée.</p>",
      "family_2": "<p><strong>Fonction systémique :</strong> Mémoire d’Or se tient à l’articulation entre <span>Katûvýsissence</span>, lumière et conscience. Les développements du manuscrit la lient à la mémoire spiralée, à la persistance du Souffle et à cette idée forte : le monde ne dure pas par oubli, mais par souvenance active.</p>",
      "word_blocks": [
        { "head": "1) Mémoire", "text": "Trace active, retenue vibrante, continuité par laquelle ce qui a été éprouvé demeure opérant sans rester figé." },
        { "head": "2) d’Or", "text": "Dans la grammaire dorée, la forme X d’Or désigne un principe, un organe ou un opérateur de cohérence." },
        { "head": "3) Ensemble", "text": "L’expression nomme l’opérateur mémoriel par lequel le Souffle se conserve en spirale dans la Katûvýsissence et continue d’agir dans la lumière, la matière et la conscience." }
      ],
      "word_notes": [
        "Le lexique trilingue atteste des équivalents EN / ES ; l’affichage maintient l’entrée canonique en français.",
        "Plan principal : Katûvýsissence / Mémoire.",
        "Fonction : conservation spiralée du Souffle dans la Katûvýsissence."
      ],
      "cta_translate": "Proposer une traduction du concept"
    },
    "EN": {
      "title": "Mémoire d’Or",
      "kicker": "Excerpt from <em>Katûpirsia&nbsp;9 — Àṣẹxel’Or</em><br />(Katûvýsissence, spiral conservation of Souffle, and vibratory memory)",
      "h_def": "Operative definition",
      "chips": ["Conceptual ideogram", "Functional ideogram"],
      "chip_urls": [CHIP_CONCEPT, CHIP_FUNCTION],
      "def_short": "Conservation spiralée du Souffle dans la Katûvýsissence.",
      "def_long": "<p>Mémoire d’Or is given, in <em>Katûpirsia&nbsp;9</em>, together with Souvenir d’Or and Or de mémoire. The canonical table of the fields and memories of Souffle states its function clearly: conservation spiralée du Souffle dans la Katûvýsissence. Its nature is defined there as vibratory memory.</p><p>In the integrated systemic reading, Mémoire d’Or belongs to the Katûvýsissence / Mémoire plane. Its global function remains the same: to conserve the Souffle without freezing it, to maintain the spiral continuity of the world in memory, and to make of trace an active principle of coherence.</p><p>The developments on the persistence of Souffle clarify this logic. Memory is not a deposit there, but a continuous transformation: nothing is lost, everything is retuned on another plane. The manuscript even says that light does not merely illuminate forms: it remembers them. Mémoire d’Or thus names light become the embodied memory of vibration, the active trace through which reality continues to remember itself.</p><p>In the dynamics of remembrance, each form keeps the memory of its original vibration and expresses it in a new amplitude. Mémoire d’Or therefore does not preserve an immobile past; it redistributes the Souffle, links matter, light, and consciousness, and keeps the universe in active fidelity to its own origin.</p>",
      "h_features": "Operative dynamics",
      "h_questions": "Applications / markers",
      "hint_fold": "expand",
      "h_family": "Systemic links",
      "h_wordbuild": "Term construction",
      "features": [
        "Spiral conservation: Mémoire d’Or conserves the Souffle within Katûvýsissence without freezing it.",
        "Vibratory memory: the trace remains active, transmissible, and operative in the present.",
        "Memorial light: light becomes the embodied memory of vibration.",
        "Continuity of reality: each form keeps the memory of its origin and expresses it in a new figure.",
        "Memorial plane of the system: in the integrated reading, it belongs to the Katûvýsissence / Mémoire plane."
      ],
      "questions": [
        "Does the encountered trace belong to a mere remainder, or to a memory still active in the field?",
        "What is conserved here without becoming fixed: a rhythm, a light, a form, a consciousness?",
        "How does memory act here as continuity rather than as the immobile return of the past?",
        "Where does vibration become memorial light, and light become operative memory?"
      ],
      "example_box": "<div><strong>Ex.</strong> In a posœnnoïal reading, when an artwork or a gesture keeps the active trace of a prior vibration while transforming it into a new presence, that bearing may be read as an effect of Mémoire d’Or.</div>",
      "family_1": "<p><strong>Internal links:</strong> <span>Mémoire d’Or</span> belongs to the <span>Katûvýsissence / Mémoire</span> plane, together with <span>Or de mémoire</span> and <span>Souvenir d’Or</span>. It maintains a direct relation with <span>Souffle d’Or</span>, whose spiral weave it conserves.</p>",
      "family_2": "<p><strong>Systemic function:</strong> Mémoire d’Or stands at the articulation of <span>Katûvýsissence</span>, light, and consciousness. The manuscript links it to spiral memory, to the persistence of Souffle, and to this strong idea: the world does not endure through forgetting, but through active remembrance.</p>",
      "word_blocks": [
        { "head": "1) Memory", "text": "Active trace, vibratory retention, continuity through which what has been experienced remains operative without staying fixed." },
        { "head": "2) d’Or", "text": "Within the golden grammar, the form X d’Or designates a principle, an organ, or an operator of coherence." },
        { "head": "3) Whole term", "text": "The expression names the memorial operator through which Souffle is conserved in spiral form within Katûvýsissence and continues to act in light, matter, and consciousness." }
      ],
      "word_notes": [
        "The trilingual lexicon attests EN / ES equivalents; display keeps the canonical entry in French.",
        "Main plane: Katûvýsissence / Mémoire.",
        "Function: conservation spiralée du Souffle dans la Katûvýsissence."
      ],
      "cta_translate": "Suggest a translation of the concept"
    },
    "ES": {
      "title": "Mémoire d’Or",
      "kicker": "Extracto de <em>Katûpirsia&nbsp;9 — Àṣẹxel’Or</em><br />(Katûvýsissence, conservación espiralada del Souffle y memoria vibrante)",
      "h_def": "Definición operativa",
      "chips": ["Ideograma conceptual", "Ideograma funcional"],
      "chip_urls": [CHIP_CONCEPT, CHIP_FUNCTION],
      "def_short": "Conservation spiralée du Souffle dans la Katûvýsissence.",
      "def_long": "<p>Mémoire d’Or es dada, en <em>Katûpirsia&nbsp;9</em>, junto con Souvenir d’Or y Or de mémoire. La tabla canónica de los campos y memorias del Souffle formula su función con claridad: conservation spiralée du Souffle dans la Katûvýsissence. Su naturaleza queda allí definida como memoria vibrante.</p><p>En la lectura sistémica integrada, Mémoire d’Or pertenece al plano Katûvýsissence / Mémoire. Su función global permanece idéntica: conservar el Souffle sin fijarlo, mantener la continuidad espiralada del mundo en la memoria y hacer de la huella un principio activo de coherencia.</p><p>Los desarrollos sobre la persistencia del Souffle aclaran esta lógica. La memoria no es allí depósito, sino transformación continua: nada se pierde, todo se reajusta en otro plano. El manuscrito llega incluso a decir que la luz no se limita a iluminar las formas: las recuerda. Mémoire d’Or nombra así la luz convertida en memoria encarnada de la vibración, la huella activa por la cual lo real sigue recordándose.</p><p>En la dinámica del recuerdo, cada forma guarda la memoria de su vibración originaria y la expresa bajo una amplitud nueva. Mémoire d’Or no conserva entonces un pasado inmóvil; redistribuye el Souffle, enlaza materia, luz y conciencia, y mantiene al universo en una fidelidad activa a su propio origen.</p>",
      "h_features": "Dinámicas operativas",
      "h_questions": "Aplicaciones / referencias",
      "hint_fold": "desplegar",
      "h_family": "Vínculos sistémicos",
      "h_wordbuild": "Construcción del término",
      "features": [
        "Conservación espiralada: Mémoire d’Or conserva el Souffle en la Katûvýsissence sin fijarlo.",
        "Memoria vibrante: la huella permanece activa, transmisible y operante en el presente.",
        "Luz memorial: la luz se vuelve memoria encarnada de la vibración.",
        "Continuidad de lo real: cada forma guarda la memoria de su origen y la expresa en una figura nueva.",
        "Plano memorial del sistema: en la lectura integrada pertenece al plano Katûvýsissence / Mémoire."
      ],
      "questions": [
        "¿La huella encontrada pertenece a un simple resto, o a una memoria todavía activa en el campo?",
        "¿Qué se conserva aquí sin fijarse: un ritmo, una luz, una forma, una conciencia?",
        "¿Cómo actúa la memoria aquí como continuidad y no como retorno inmóvil del pasado?",
        "¿Dónde la vibración se vuelve luz memorial y la luz se vuelve memoria operativa?"
      ],
      "example_box": "<div><strong>Ej.</strong> En una lectura posœnnoïal, cuando una obra o un gesto guarda la huella activa de una vibración anterior mientras la transforma en presencia nueva, esa tenida puede leerse como un efecto de Mémoire d’Or.</div>",
      "family_1": "<p><strong>Vínculos internos:</strong> <span>Mémoire d’Or</span> pertenece al plano <span>Katûvýsissence / Mémoire</span>, junto con <span>Or de mémoire</span> y <span>Souvenir d’Or</span>. Mantiene una relación directa con <span>Souffle d’Or</span>, cuya trama espiralada conserva.</p>",
      "family_2": "<p><strong>Función sistémica:</strong> Mémoire d’Or se sitúa en la articulación entre <span>Katûvýsissence</span>, luz y conciencia. El manuscrito la vincula con la memoria espiralada, con la persistencia del Souffle y con esta idea fuerte: el mundo no dura por olvido, sino por recordación activa.</p>",
      "word_blocks": [
        { "head": "1) Memoria", "text": "Huella activa, retención vibrante, continuidad por la cual lo vivido permanece operante sin quedar fijado." },
        { "head": "2) d’Or", "text": "En la gramática dorada, la forma X d’Or designa un principio, un órgano o un operador de coherencia." },
        { "head": "3) Conjunto", "text": "La expresión nombra el operador memorial por el cual el Souffle se conserva en espiral en la Katûvýsissence y sigue actuando en la luz, la materia y la conciencia." }
      ],
      "word_notes": [
        "El léxico trilingüe atestigua equivalentes EN / ES; la visualización mantiene la entrada canónica en francés.",
        "Plano principal: Katûvýsissence / Mémoire.",
        "Función: conservation spiralée du Souffle dans la Katûvýsissence."
      ],
      "cta_translate": "Proposer une traduction du concept"
    }
  };

  function updateButtons(root, lang){
    var btns = root.querySelectorAll('.po-langbtn');
    Array.prototype.forEach.call(btns, function(btn){
      var active = btn.getAttribute('data-po-lang') === lang;
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function wireButtons(root){
    if (root.__po_lang_bound) return;
    root.__po_lang_bound = true;
    var btns = root.querySelectorAll('.po-langbtn');
    Array.prototype.forEach.call(btns, function(btn){
      btn.addEventListener('click', function(){
        var lang = normLang(btn.getAttribute('data-po-lang') || 'FR');
        applyLangEverywhere(lang);
      });
    });
  }

  /* AUDIO LOCAL PAR BLOC + TEXTE GÉNÉRAL */
  var PO_AUDIO_SYNTH = (typeof window !== "undefined" && window.speechSynthesis) ? window.speechSynthesis : null;
  var PO_AUDIO_STATE = { root:null, units:[], unitPos:-1, chunks:[], chunkPos:-1, activeKey:"", lang:"FR", voice:null };
  var AUDIO_UI = {
    FR: { general: "Écouter le texte", block: "Écouter ce bloc", stop: "Arrêter la lecture" },
    EN: { general: "Listen to the text", block: "Listen to this section", stop: "Stop playback" },
    ES: { general: "Escuchar el texto", block: "Escuchar este bloque", stop: "Detener la lectura" }
  };

  function audioUI(lang){ return AUDIO_UI[normLang(lang)] || AUDIO_UI.FR; }

  function ensureAudioStyles(){
    if (document.getElementById("po-axis-audio-styles-memoire-d-or")) return;
    var style = document.createElement("style");
    style.id = "po-axis-audio-styles-memoire-d-or";
    style.textContent =
      ".po-axis-audio-wrap{display:flex;justify-content:center;margin:10px 0;}" +
      ".po-axis-audio-btn{appearance:none;border:1px solid rgba(0,0,0,.14);background:rgba(255,255,255,.72);color:inherit;border-radius:999px;padding:7px 12px;font:inherit;font-size:12px;line-height:1.1;cursor:pointer;}" +
      ".po-axis-audio-btn.is-on{border-color:rgba(184,134,11,.55);box-shadow:0 0 0 1px rgba(184,134,11,.18);font-weight:700;}" +
      ".po-lex-summary .po-axis-audio-wrap{display:inline-flex;justify-content:flex-end;margin:0 0 0 auto;}" +
      ".po-lex-summary .po-axis-audio-btn{padding:5px 9px;font-size:11px;}";
    document.head.appendChild(style);
  }

  function getAudioRoots(){
    return Array.prototype.slice.call(document.querySelectorAll(ROOT_SEL) || []);
  }

  function getDetailBlocks(root){
    return root ? Array.prototype.slice.call(root.querySelectorAll(".po-lex-details") || []) : [];
  }

  function getTextValue(el){
    if (!el) return "";
    var txt = "";
    try{ txt = el.textContent || el.innerText || ""; }catch(e){ txt = ""; }
    return clampStr(txt).replace(/\s+/g, " ").trim();
  }

  function removeAudioButtonsFromClone(root){
    if (!root || !root.querySelectorAll) return;
    var nodes = root.querySelectorAll(".po-axis-audio-wrap, .po-axis-audio-btn");
    for (var i=0;i<nodes.length;i++) if (nodes[i] && nodes[i].parentNode) nodes[i].parentNode.removeChild(nodes[i]);
  }

  function collectGeneralText(root){
    var slots = ["title", "kicker", "h_def", "def_short", "def_long"];
    var parts = [];
    for (var i=0;i<slots.length;i++){
      var el = root.querySelector("[data-po-slot='" + slots[i] + "']");
      var txt = getTextValue(el);
      if (txt) parts.push(txt);
    }
    return parts.join(". ");
  }

  function collectDetailText(detail){
    if (!detail) return "";
    var clone = detail.cloneNode(true);
    removeAudioButtonsFromClone(clone);
    var title = getTextValue(clone.querySelector(".po-lex-summary__title"));
    var body = "";
    try{
      var summary = clone.querySelector(".po-lex-summary");
      if (summary && summary.parentNode) summary.parentNode.removeChild(summary);
      body = getTextValue(clone);
    }catch(e){ body = ""; }
    return [title, body].filter(Boolean).join(". ");
  }

  function splitSpeechChunks(text){
    var src = clampStr(text).replace(/\s+/g, " ").trim();
    if (!src) return [];
    var raw = src.split(/(?<=[\.\!\?\:\;])\s+/);
    var out = [];
    var buf = "";
    var limit = 220;
    for (var i=0;i<raw.length;i++){
      var part = clampStr(raw[i]).trim();
      if (!part) continue;
      if (!buf){ buf = part; continue; }
      if ((buf + " " + part).length <= limit) buf += " " + part;
      else { out.push(buf); buf = part; }
    }
    if (buf) out.push(buf);
    return out;
  }

  function guessSpeechLang(lang){
    var L = normLang(lang);
    if (L === "EN") return "en";
    if (L === "ES") return "es";
    return "fr";
  }

  function pickVoice(lang){
    if (!PO_AUDIO_SYNTH || !PO_AUDIO_SYNTH.getVoices) return null;
    var voices = PO_AUDIO_SYNTH.getVoices() || [];
    var shortLang = guessSpeechLang(lang);
    var prefix = shortLang + "-";
    for (var i=0;i<voices.length;i++){
      var vl = clampStr(voices[i].lang).toLowerCase();
      if (vl === shortLang || vl.indexOf(prefix) === 0) return voices[i];
    }
    return voices[0] || null;
  }

  function setAudioButtonsState(root, key, isOn){
    if (!root) return;
    var btns = root.querySelectorAll(".po-axis-audio-btn");
    for (var i=0;i<btns.length;i++){
      var btn = btns[i];
      var match = clampStr(btn.getAttribute("data-po-audio-key")) === clampStr(key);
      if (match && isOn) btn.classList.add("is-on");
      else btn.classList.remove("is-on");
    }
  }

  function stopAudio(){
    try{ if (PO_AUDIO_SYNTH) PO_AUDIO_SYNTH.cancel(); }catch(e){}
    setAudioButtonsState(PO_AUDIO_STATE.root, PO_AUDIO_STATE.activeKey, false);
    PO_AUDIO_STATE.root = null;
    PO_AUDIO_STATE.units = [];
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = "";
    PO_AUDIO_STATE.voice = null;
  }

  function speakCurrentChunk(){
    if (!PO_AUDIO_SYNTH) return stopAudio();
    if (PO_AUDIO_STATE.chunkPos >= PO_AUDIO_STATE.chunks.length) return playNextUnit();
    var txt = PO_AUDIO_STATE.chunks[PO_AUDIO_STATE.chunkPos];
    if (!txt){ PO_AUDIO_STATE.chunkPos += 1; return speakCurrentChunk(); }
    var utter = new SpeechSynthesisUtterance(txt);
    utter.lang = guessSpeechLang(PO_AUDIO_STATE.lang);
    if (PO_AUDIO_STATE.voice) utter.voice = PO_AUDIO_STATE.voice;
    utter.onend = function(){ PO_AUDIO_STATE.chunkPos += 1; speakCurrentChunk(); };
    utter.onerror = function(){ PO_AUDIO_STATE.chunkPos += 1; speakCurrentChunk(); };
    try{ PO_AUDIO_SYNTH.speak(utter); }catch(e){ stopAudio(); }
  }

  function playNextUnit(){
    PO_AUDIO_STATE.unitPos += 1;
    if (PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length) return stopAudio();
    var unit = PO_AUDIO_STATE.units[PO_AUDIO_STATE.unitPos];
    if (!unit || !unit.text) return playNextUnit();
    if (unit.detail && !unit.detail.open) unit.detail.open = true;
    PO_AUDIO_STATE.chunks = splitSpeechChunks(unit.text);
    PO_AUDIO_STATE.chunkPos = 0;
    speakCurrentChunk();
  }

  function startAudio(root, role, index){
    if (!root || !PO_AUDIO_SYNTH) return;
    stopAudio();
    var units = [];
    if (role === "general"){
      var general = collectGeneralText(root);
      if (general) units.push({ key:"general", text:general, detail:null });
    }
    var details = getDetailBlocks(root);
    var start = (role === "block" && index >= 0) ? index : 0;
    for (var i=start;i<details.length;i++){
      var txt = collectDetailText(details[i]);
      if (txt) units.push({ key:"block-" + i, text:txt, detail:details[i] });
    }
    if (!units.length) return;
    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.units = units;
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.activeKey = role === "general" ? "general" : ("block-" + index);
    PO_AUDIO_STATE.lang = getLang();
    PO_AUDIO_STATE.voice = pickVoice(PO_AUDIO_STATE.lang);
    setAudioButtonsState(root, PO_AUDIO_STATE.activeKey, true);
    playNextUnit();
  }

  function createAudioButton(role, index){
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "po-axis-audio-btn notranslate";
    btn.setAttribute("translate", "no");
    btn.setAttribute("data-po-audio-role", role);
    if (role === "block") btn.setAttribute("data-po-audio-index", String(index));
    btn.setAttribute("data-po-audio-key", role === "general" ? "general" : ("block-" + index));
    return btn;
  }

  function ensureAudioButtons(root){
    if (!root) return;
    ensureAudioStyles();
    var generalWrap = root.querySelector(".po-axis-audio-wrap[data-po-audio-role='general']");
    if (!generalWrap){
      generalWrap = document.createElement("div");
      generalWrap.className = "po-axis-audio-wrap";
      generalWrap.setAttribute("data-po-audio-role", "general");
      generalWrap.appendChild(createAudioButton("general", -1));
      var meta = root.querySelector(".po-axis-meta");
      var defShort = root.querySelector("[data-po-slot='def_short']");
      var firstDetails = root.querySelector(".po-lex-details");
      if (meta && meta.parentNode) meta.parentNode.insertBefore(generalWrap, meta.nextSibling);
      else if (defShort && defShort.parentNode) defShort.parentNode.insertBefore(generalWrap, defShort);
      else if (firstDetails && firstDetails.parentNode) firstDetails.parentNode.insertBefore(generalWrap, firstDetails);
    }
    var details = getDetailBlocks(root);
    for (var i=0;i<details.length;i++){
      var summary = details[i].querySelector(".po-lex-summary");
      if (!summary) continue;
      var wrap = summary.querySelector(".po-axis-audio-wrap[data-po-audio-role='block']");
      if (!wrap){
        wrap = document.createElement("span");
        wrap.className = "po-axis-audio-wrap";
        wrap.setAttribute("data-po-audio-role", "block");
        wrap.appendChild(createAudioButton("block", i));
        summary.appendChild(wrap);
      }
    }
  }

  function refreshAudioLabels(root, lang){
    if (!root) return;
    var ui = audioUI(lang);
    var btns = root.querySelectorAll(".po-axis-audio-btn");
    for (var i=0;i<btns.length;i++){
      var btn = btns[i];
      var role = btn.getAttribute("data-po-audio-role");
      var key = btn.getAttribute("data-po-audio-key");
      var isOn = PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === key && PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending);
      btn.textContent = isOn ? ui.stop : (role === "general" ? ui.general : ui.block);
    }
  }

  function bindAudioButtons(root){
    var btns = root.querySelectorAll(".po-axis-audio-btn");
    for (var i=0;i<btns.length;i++){
      var btn = btns[i];
      if (btn.__poAudioBound) continue;
      btn.addEventListener("click", function(ev){
        ev.preventDefault();
        ev.stopPropagation();
        var role = this.getAttribute("data-po-audio-role") || "general";
        var key = this.getAttribute("data-po-audio-key") || "";
        var index = parseInt(this.getAttribute("data-po-audio-index"), 10);
        var sameRoot = (PO_AUDIO_STATE.root === root);
        var sameKey = (PO_AUDIO_STATE.activeKey === key);
        if (sameRoot && sameKey && PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending)){
          stopAudio();
          refreshAudioLabels(root, getLang());
          return;
        }
        startAudio(root, role, isNaN(index) ? -1 : index);
        refreshAudioLabels(root, getLang());
      });
      btn.__poAudioBound = true;
    }
  }

  function initAudioEverywhere(lang){
    var roots = getAudioRoots();
    for (var i=0;i<roots.length;i++){
      ensureAudioButtons(roots[i]);
      bindAudioButtons(roots[i]);
      refreshAudioLabels(roots[i], lang || getLang());
    }
  }

  function renderRoot(root, lang){
    var T = CONTENT[lang] || CONTENT.FR;
    setSlotText(root, 'title', T.title);
    setSlotHTML(root, 'kicker', T.kicker);
    setSlotImgSrc(root, 'title_img', T.chip_urls[0], T.title);
    setSlotText(root, 'h_def', T.h_def);
    setSlotText(root, 'chip_1', T.chips[0]);
    setSlotText(root, 'chip_2', T.chips[1]);
    setSlotImgSrc(root, 'chip_1_img', T.chip_urls[0], T.chips[0]);
    setSlotImgSrc(root, 'chip_2_img', T.chip_urls[1], T.chips[1]);
    setSlotText(root, 'def_short', T.def_short);
    setSlotHTML(root, 'def_long', T.def_long);
    setSlotText(root, 'h_features', T.h_features);
    setSlotText(root, 'h_questions', T.h_questions);
    setSlotText(root, 'hint_fold', T.hint_fold);
    setSlotText(root, 'hint_fold2', T.hint_fold);
    setSlotText(root, 'h_family', T.h_family);
    setSlotText(root, 'hint_fold3', T.hint_fold);
    setSlotText(root, 'h_wordbuild', T.h_wordbuild);
    setSlotText(root, 'hint_fold4', T.hint_fold);
    renderListInto(root, 'features', T.features);
    renderListInto(root, 'questions', T.questions);
    setSlotHTML(root, 'example_box', T.example_box);
    setSlotHTML(root, 'family_1', T.family_1);
    setSlotHTML(root, 'family_2', T.family_2);
    renderWordBlocks(root, 'wordbuild_blocks', T.word_blocks);
    renderListInto(root, 'wordbuild_notes', T.word_notes);
    setSlotText(root, 'cta_translate', T.cta_translate);
    updateButtons(root, lang);
    wireButtons(root);
  }

  function applyLangEverywhere(lang3){
    var lang = storeLang(lang3);
    var roots = document.querySelectorAll(ROOT_SEL);
    Array.prototype.forEach.call(roots, function(root){ renderRoot(root, lang); });
    initAudioEverywhere(lang);
    notifyLocaleChanged();
  }

  function init(){ applyLangEverywhere(getLang()); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.PoKatupirsia9MemoireDOrTextsFR_EN_ES_20260326 = {
    init: init,
    setLang: applyLangEverywhere,
    getLang: getLang,
    normLang: normLang,
    stopAudio: stopAudio
  };
})();
